import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/sys/mini/information";

export default {
    /** 分页查询信息列表（parentId 严格匹配） */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 查询信息树（上级节点选择） */
    queryTree: () => axios.get({url: `${PREFIX_URI}/queryTree`}),
    /** 查询详情 */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id}}),
    /** 保存 */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data}),
    /** 删除 */
    delete: (id) => axios.get({url: `${PREFIX_URI}/delete`, data: {id}}),
};
